import { uploadBlob } from '@/util/oss';
import { updateRecord, getConfig } from '@/api/amis/index';
import Vue from 'vue';
import {
  RRWEB_ERROR_MESSAGE,
  RRWEB_RECORD_STATE,
  RRWEB_RECORD_MODE,
} from './const';
import { splitDataIntoChunks } from './utils';
import RRWebRecorder from './core';
import { initRecordUI } from './recordUI';

const MAX_CHUNK_SIZE = 40 * 1024 * 1024; // 40MB
class RRWebMonitor {
  static instance;
  recorder;
  vueApp;
  userId;
  recordState;
  recordMode;
  loading;

  constructor() {
    this.recordState = RRWEB_RECORD_STATE.init;
    this.loading = false;
    this.recorder = new RRWebRecorder();
  }

  static getInstance() {
    if (!RRWebMonitor.instance) {
      RRWebMonitor.instance = new RRWebMonitor();
    }
    return RRWebMonitor.instance;
  }

  init(vueApp) {
    try {
      this.vueApp = vueApp;
      const userInfo = JSON.parse(sessionStorage.getItem('iol8cloud-userInfo'));
      this.userId = userInfo?.content?.staffId;
      this.userId && this.initMonitor();
    } catch (error) {
      console.error('=====rrweb====：', error);
    }
  }

  initMonitor() {
    getConfig('dot-admin').then((res) => {
      const { open, userWhiteList } = res?.data?.data;

      if (open) {
        if (userWhiteList.indexOf(this.userId) != -1) {
          this.actionMonitor();
        } else {
          this.errorMonitor();
        }
      }
    });
  }

  // ============行为录制============
  actionMonitor() {
    initRecordUI(this, this.recorder);
    this.recordMode = RRWEB_RECORD_MODE.action;
  }

  async batchSubmitData() {
    const events = this.recorder.getAllData();
    // 倒序，这样播放时从上往下更方便
    const chunks = splitDataIntoChunks(events, MAX_CHUNK_SIZE)?.reverse();
    for (let index = 0; index < chunks.length; index++) {
      const chunk = chunks[index];
      await new Promise((resolve) =>
        this.submitRecordData(chunk).finally(resolve),
      );
    }

    // 上传完成
    this.recorder.clearRecords();
    this.recordState = RRWEB_RECORD_STATE.init;
    return Promise.resolve();
  }

  // ============错误录制============
  errorMonitor() {
    this.recorder.start();
    this.recorder.loopClear();

    this.recordMode = RRWEB_RECORD_MODE.error;

    window.onerror = this.handleError.bind(this);
    this.vueApp.config.errorHandler = this.handleError.bind(this);
  }

  handleError() {
    const events = this.recorder.getResentData();
    this.submitRecordData(events).finally(() => {
      this.recorder.clearRecords();
    });
  }

  // ============通用 - 上报数据============
  async submitRecordData(data) {
    this.loading = true;
    return new Promise(async (resolve, reject) => {
      const recordData = JSON.stringify({ data });
      const blob = new Blob([recordData], { type: 'text/plain' });
      console.log('====chunk-size====', blob.size / 1024 / 1024);
      let url = '';
      // 上传录制文件
      try {
        url = await uploadBlob(blob);
      } catch (error) {
        reject(RRWEB_ERROR_MESSAGE.report_error);
      }

      // 上报数据
      try {
        await updateRecord({
          client: 'dot-admin',
          userId: this.userId,
          path: window.location.href,
          url: url,
        });
        resolve(url);
      } catch (error) {
        reject(RRWEB_ERROR_MESSAGE.upload_error);
      }
    }).finally(() => {
      this.loading = false;
    });
  }
}

// 使用示例
const rrWebMonitor = RRWebMonitor.getInstance();
export default rrWebMonitor;
